import axios from "axios";
import {
  ChecklistResponse,
  ChecklistGrupo,
  ChecklistPergunta,
  ChecklistResposta,
} from "../types/editChecklist";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_DOMAIN || "",
  headers: {
    "Content-Type": "application/json",
  },
});

function tokenHeader(token?: string) {
  return {
    headers: {
      Authorization: `Bearer ${token || localStorage.getItem("token")}`,
    },
  };
}

/* CHECKLIST PRINCIPAL */
export const getChecklistById = async (
  token: string,
  id: number
): Promise<ChecklistResponse> => {
  const { data } = await api.get<ChecklistResponse>(
    `/manager/checklist/${id}`,
    tokenHeader(token)
  );
  return data;
};

export const putChecklist = async (
  token: string,
  id: number,
  body: Partial<ChecklistResponse>
) => {
  const { data } = await api.put(
    `/manager/checklist/${id}`,
    body,
    tokenHeader(token)
  );
  return data;
};

/* GRUPO */
export const getChecklistGrupoById = async (
  token: string,
  grupoId: number
): Promise<ChecklistGrupo> => {
  const { data } = await api.get<ChecklistGrupo>(
    `/manager/checklistgrupo/${grupoId}`,
    tokenHeader(token)
  );
  return data;
};

export const putChecklistGrupo = async (
  token: string,
  grupoId: number,
  body: Partial<ChecklistGrupo>
) => {
  const { data } = await api.put(
    `/manager/checklistgrupo/${grupoId}`,
    body,
    tokenHeader(token)
  );
  return data;
};

export const createChecklistGrupo = async (
  token: string,
  body: Partial<ChecklistGrupo>
) => {
  const { data } = await api.post(
    `/manager/checklistgrupo`,
    body,
    tokenHeader(token)
  );
  return data;
};

export const deleteChecklistGrupo = async (token: string, grupoId: number) => {
  const { data } = await api.delete(
    `/manager/checklistgrupo/${grupoId}`,
    tokenHeader(token)
  );
  return data;
};

/* PERGUNTA */
export const getChecklistPerguntaById = async (
  token: string,
  perguntaId: number
): Promise<ChecklistPergunta> => {
  const { data } = await api.get<ChecklistPergunta>(
    `/manager/checklistpergunta/${perguntaId}`,
    tokenHeader(token)
  );
  return data;
};

export const putChecklistPergunta = async (
  token: string,
  perguntaId: number,
  body: Partial<ChecklistPergunta>
) => {
  const { data } = await api.put(
    `/manager/checklistpergunta/${perguntaId}`,
    body,
    tokenHeader(token)
  );
  return data;
};

export const deleteChecklistPergunta = async (
  token: string,
  perguntaId: number
) => {
  const { data } = await api.delete(
    `/manager/checklistpergunta/${perguntaId}`,
    tokenHeader(token)
  );
  return data;
};

/* RESPOSTA */
export const getChecklistRespostaById = async (
  token: string,
  respostaId: number
): Promise<ChecklistResposta> => {
  const { data } = await api.get<ChecklistResposta>(
    `/manager/checklistresposta/${respostaId}`,
    tokenHeader(token)
  );
  return data;
};

export const putChecklistResposta = async (
  token: string,
  respostaId: number,
  body: Partial<ChecklistResposta>
) => {
  const { data } = await api.put(
    `/manager/checklistresposta/${respostaId}`,
    body,
    tokenHeader(token)
  );
  return data;
};
